import React, { useState } from "react";
import "./App.css";
import LandingHero from "./components/LandingHero";
import PlaygroundPage from "./components/PlaygroundPage";

function App() {
  const [showPlayground, setShowPlayground] = useState(false);

  if (showPlayground) {
    return (
      <main>
        <PlaygroundPage onBack={() => setShowPlayground(false)} />
      </main>
    );
  }

  return (
    <main>
      <LandingHero onStartAnimating={() => setShowPlayground(true)} />
    </main>
  );
}

export default App;
